<template>
  <header class="ui-page-toolbar">
    <div class="ui-page-toolbar__title">
      <i v-if="icon" :class="icon" aria-hidden="true"></i>
      <span v-else class="ui-page-toolbar__marker" aria-hidden="true"></span>
      <h1>{{ $t(title) }}</h1>
    </div>
    <div v-if="$slots.actions" class="ui-page-toolbar__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'UiPageToolbar',
  props: {
    title: { type: String, required: true },
    icon: { type: [String, Array, Object], default: '' }
  }
}
</script>

<style lang="scss" scoped>
.ui-page-toolbar {
  width: 100%;
  height: 62px;
  min-height: 62px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ui-space-lg);
  padding: 0 var(--ui-space-sm);
  border: 1px solid var(--ui-border-color-subtle);
  border-radius: var(--ui-radius-medium);
  background: rgba(var(--ui-bg-elevated-rgb), .42);
  box-sizing: border-box;
}

.ui-page-toolbar__title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--ui-space-sm);
}

.ui-page-toolbar__title > i {
  flex: none;
  color: var(--ui-color-primary);
  font-size: 20px;
  font-weight: 400;
}

.ui-page-toolbar__title h1 {
  margin: 0;
  overflow: hidden;
  color: var(--ui-text-primary);
  font-size: var(--ui-font-size-page-title);
  font-weight: var(--ui-font-weight-bold);
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ui-page-toolbar__marker {
  flex: none;
  width: 2px;
  height: 14px;
  border-radius: 1px;
  background: var(--ui-color-primary);
}

.ui-page-toolbar__actions {
  flex: none;
  display: flex;
  align-items: center;
  gap: var(--ui-control-gap);
}

.ui-page-toolbar__actions :deep(.el-button + .el-button) {
  margin-left: 0;
}
</style>
